// import { Roles } from '@models/Account';
// import BaseApi from '../BaseApi';
// import envStore from '@utils/env';

// const AuthServiceApi = {
//   CreateUser: (data: any) => {
//     return BaseApi.POST('api/Auth/Create', data, envStore.url_auth);
//   },
//   CreateUserV2: (data: any) => {
//     return BaseApi.POST('api/Auth/CreateV2', data, envStore.url_auth);
//   },
//   Login: (data: any) => {
//     return BaseApi.POST('api/Auth/Login', data, envStore.url_auth);
//   },
//   LoginV2: (data: any) => {
//     return BaseApi.POST('api/Auth/LoginV2', data, envStore.url_auth);
//   },
//   RefreshToken: (data: { refreshToken: string; os: string; version: string }) => {
//     return BaseApi.POST('api/Auth/RefreshToken', data, envStore.url_auth);
//   },
//   // get all user...
//   // Lấy quyền và thông tin của tài khoản
//   GetRole: () => {
//     return BaseApi.GET('api/Auth/GetUserInfo', envStore.url_auth);
//   },
//   GetRoleV2: () => {
//     return BaseApi.GET('api/Auth/GetUserInfoV2', envStore.url_auth);
//   },
//   Logout: () => {
//     return BaseApi.GET('api/Auth/Logout', envStore.url_auth);
//   },
//   LogoutV2: (refreshToken: any) => {
//     return BaseApi.POST('api/Auth/LogoutV2', refreshToken, envStore.url_auth);
//   },
//   UpdateUserInfo: (data: any) => {
//     return BaseApi.PUT('api/Auth/Update', data, envStore.url_auth);
//   },
//   UpdateUserInfoV2: (data: any) => {
//     return BaseApi.PUT('api/Auth/UpdateV2', data, envStore.url_auth);
//   },
//   UpdateUserAvatar: (data: any) => {
//     return BaseApi.PUT('api/Auth/UploadAvatar', data, envStore.url_auth);
//   },
//   ChangeCurrentInfoAcc: (data: any) => {
//     return BaseApi.PUT('api/Auth/UpdateUserInfo', data, envStore.url_auth);
//   },
//   ChangePassword: (oldPassword: string, newPassword: string, reEnterNewPassword: string) => {
//     return BaseApi.PUT(
//       `api/Auth/ChangePassword?oldPassword=${oldPassword}&newPassword=${newPassword}&reEnterNewPassword=${reEnterNewPassword}`,
//       {},
//       envStore.url_auth
//     );
//   },
//   ResetPassword: (username: any) => {
//     return BaseApi.PUT(`api/Auth/ResetPassword?username=${username}`, {}, envStore.url_auth);
//   },
//   LockUser: (username: any) => {
//     return BaseApi.PUT(`api/Auth/LockUser?username=${username}`, {}, envStore.url_auth);
//   },
//   UnLockUser: (username: any) => {
//     return BaseApi.PUT(`api/Auth/UnlockUser?username=${username}`, {}, envStore.url_auth);
//   },
//   GetAllUser: () => {
//     return BaseApi.GET('api/Auth/GetAll', envStore.url_auth);
//   },
//   GetAllUserSales: () => {
//     return BaseApi.GET('api/Auth/GetListSale', envStore.url_auth);
//   },
//   GetListUserByRoleV2: (roleName: any) => {
//     return BaseApi.GET(`api/Auth/GetListUserByRoleV2?roleName=${roleName}`, envStore.url_auth);
//   },
//   GetAllUserCustomerV2: (dataBody: any, pageIndex: any, pageSize: any) => {
//     return BaseApi.POST(
//       `api/Customer/AdvanceSearchCustomer?pageSize=${pageSize}&pageIndex=${pageIndex !== 0 ? pageIndex : 1}`,
//       dataBody,
//       envStore.url_auth
//     );
//   },
//   GetAllUserCustomerV3: (dataBody: any, pageIndex: any, pageSize: any) => {
//     return BaseApi.POST(
//       `api/Customer/AdvanceSearchCustomerMergeCustomerService?pageSize=${pageSize}&pageIndex=${
//         pageIndex !== 0 ? pageIndex : 1
//       }`,
//       dataBody,
//       envStore.url_auth
//     );
//   },
//   GetAllUserV2: () => {
//     return BaseApi.GET('api/Auth/GetAllV2', envStore.url_auth);
//   },
//   GetUsersByRole: (role: Roles) => {
//     return BaseApi.GET(`api/Auth/GetListUserByRole?roleName=${role}`, envStore.url_auth);
//   },
//   GetUsersByRoleV2: (role: Roles) => {
//     return BaseApi.GET(`api/Auth/GetListUserByRoleV2?roleName=${role}`, envStore.url_auth);
//   },
//   CheckSystem: () => {
//     return BaseApi.GET('api/SysMessage/Get', envStore.url_auth);
//   },
//   CheckExpireToken: () => {
//     return BaseApi.GET('api/Auth/IsValidToken', envStore.url_auth);
//   },
//   UpdateDeviceToken: (data: any) => {
//     return BaseApi.PUT('api/Auth/UpdateDeviceToken', data, envStore.url_auth);
//   },
//   RemoveDeviceToken: (data: any) => {
//     return BaseApi.POST('api/Auth/DeleteDeviceToken', data, envStore.url_auth);
//   },
//   GetAccountPhoneInfo: (data: any) => {
//     return BaseApi.GET(`api/Auth/GetAccountPhoneInfo?username=${data}`, envStore.url_auth);
//   }
// };

// export default AuthServiceApi;

import { Roles } from '@models/Account';
import BaseApi from '../BaseApi';
import envStore from '@utils/env';

const AuthServiceApi = {
  CreateUser: (data: any) => {
    return BaseApi.POST('api/Auth/Create', data, envStore.url_auth);
  },
  CreateUserV2: (data: any) => {
    return BaseApi.POST('api/Auth/CreateV2', data, envStore.url_auth);
  },
  Login: (data: any) => {
    return BaseApi.POST('api/Auth/Login', data, envStore.url_auth);
  },
  LoginV2: (data: any) => {
    return BaseApi.POST('api/Auth/LoginV2', data, envStore.url_auth);
  },
  RefreshToken: (data: { refreshToken: string; os: string; version: string }) => {
    return BaseApi.POST('api/Auth/RefreshToken', data, envStore.url_auth);
  },
  // get all user...
  // Lấy quyền và thông tin của tài khoản
  GetRole: () => {
    return BaseApi.GET('api/Auth/GetUserInfo', envStore.url_auth);
  },
  GetRoleV2: () => {
    return BaseApi.GET('api/Auth/GetUserInfoV2', envStore.url_auth);
  },
  Logout: () => {
    return BaseApi.GET('api/Auth/Logout', envStore.url_auth);
  },
  LogoutV2: (refreshToken: any) => {
    return BaseApi.POST('api/Auth/LogoutV2', refreshToken, envStore.url_auth);
  },
  UpdateUserInfo: (data: any) => {
    return BaseApi.PUT('api/Auth/Update', data, envStore.url_auth);
  },
  UpdateUserInfoV2: (data: any) => {
    return BaseApi.PUT('api/Auth/UpdateV2', data, envStore.url_auth);
  },
  UpdateUserAvatar: (data: any) => {
    return BaseApi.PUT('api/Auth/UploadAvatar', data, envStore.url_auth);
  },
  ChangeCurrentInfoAcc: (data: any) => {
    return BaseApi.PUT('api/Auth/UpdateUserInfo', data, envStore.url_auth);
  },
  ChangePassword: (oldPassword: string, newPassword: string, reEnterNewPassword: string) => {
    return BaseApi.PUT(
      `api/Auth/ChangePassword?oldPassword=${oldPassword}&newPassword=${newPassword}&reEnterNewPassword=${reEnterNewPassword}`,
      {},
      envStore.url_auth
    );
  },
  ResetPassword: (username: any) => {
    return BaseApi.PUT(`api/Auth/ResetPassword?username=${username}`, {}, envStore.url_auth);
  },
  LockUser: (username: any) => {
    return BaseApi.PUT(`api/Auth/LockUser?username=${username}`, {}, envStore.url_auth);
  },
  UnLockUser: (username: any) => {
    return BaseApi.PUT(`api/Auth/UnlockUser?username=${username}`, {}, envStore.url_auth);
  },
  GetAllUser: () => {
    return BaseApi.GET('api/Auth/GetAll', envStore.url_auth);
  },
  GetAllUserSales: () => {
    return BaseApi.GET('api/Auth/GetListSale', envStore.url_auth);
  },
  GetListUserByRoleV2: (roleName: any) => {
    return BaseApi.GET(`api/Auth/GetListUserByRoleV2?roleName=${roleName}`, envStore.url_auth);
  },
  GetAllUserCustomerV2: (dataBody: any, pageIndex: any, pageSize: any) => {
    return BaseApi.POST(
      `api/Customer/AdvanceSearchCustomer?pageSize=${pageSize}&pageIndex=${pageIndex !== 0 ? pageIndex : 1}`,
      dataBody,
      envStore.url_auth
    );
  },
  GetAllUserCustomerV3: (dataBody: any, pageIndex: any, pageSize: any) => {
    return BaseApi.POST(
      `api/Customer/AdvanceSearchCustomerMergeCustomerService?pageSize=${pageSize}&pageIndex=${
        pageIndex !== 0 ? pageIndex : 1
      }`,
      dataBody,
      envStore.url_auth
    );
  },
  GetAllUserV2: () => {
    return BaseApi.GET('api/Auth/GetAllV2', envStore.url_auth);
  },
  GetUsersByRole: (role: Roles) => {
    return BaseApi.GET(`api/Auth/GetListUserByRole?roleName=${role}`, envStore.url_auth);
  },
  GetUsersByRoleV2: (role: Roles) => {
    return BaseApi.GET(`api/Auth/GetListUserByRoleV2?roleName=${role}`, envStore.url_auth);
  },
  CheckSystem: () => {
    return BaseApi.GET('api/SysMessage/Get', envStore.url_auth);
  },
  CheckExpireToken: () => {
    return BaseApi.GET('api/Auth/IsValidToken', envStore.url_auth);
  },
  UpdateDeviceToken: (data: any) => {
    return BaseApi.PUT('api/Auth/UpdateDeviceToken', data, envStore.url_auth);
  },
  // V2: hỗ trợ isShortSession để server tự ngưng push notify khi không ghi nhớ đăng nhập
  UpdateDeviceTokenV2: (data: {
    deviceToken: string;
    platform: string;
    version: string;
    deviceId: string;
    isShortSession: boolean;
  }) => {
    return BaseApi.PUT('api/Auth/UpdateDeviceTokenV2', data, envStore.url_auth);
  },
  RemoveDeviceToken: (data: any) => {
    return BaseApi.POST('api/Auth/DeleteDeviceToken', data, envStore.url_auth);
  },
  GetAccountPhoneInfo: (data: any) => {
    return BaseApi.GET(`api/Auth/GetAccountPhoneInfo?username=${data}`, envStore.url_auth);
  }
};

export default AuthServiceApi;
